export default {
	title: "Register",
	subtitle: "Choose your interest",
    back: 'Back',
	seller: "Seller",
	buyer: "Buyer",
	deliverer: "Deliverer",
	buttons: {
		register: "Register",
		login: "Login",
	},
};
